var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.368 2.79005L3.632 1.87705C3.33133 1.77691 3.01118 1.74964 2.69791 1.79751C2.38464 1.84538 2.08723 1.967 1.83019 2.15236C1.57315 2.33772 1.36383 2.58151 1.21949 2.86363C1.07516 3.14576 0.999924 3.45814 1 3.77505V15.558C0.999899 15.978 1.13198 16.3873 1.37752 16.7279C1.62305 17.0686 1.96959 17.3233 2.368 17.456L6.368 18.789C6.77825 18.9257 7.22175 18.9257 7.632 18.789L12.368 17.211C12.7783 17.0744 13.2217 17.0744 13.632 17.211L16.368 18.123C16.6687 18.2232 16.989 18.2505 17.3023 18.2025C17.6157 18.1546 17.9132 18.0329 18.1702 17.8474C18.4273 17.662 18.6366 17.418 18.7808 17.1358C18.9251 16.8535 19.0002 16.541 19 16.224V4.44205C19.0002 4.02224 18.8682 3.61302 18.6229 3.27237C18.3775 2.93172 18.0312 2.67692 17.633 2.54405L13.633 1.21105C13.2224 1.07418 12.7786 1.07418 12.368 1.21105L7.631 2.78905C7.22074 2.92569 6.77725 2.92569 6.367 2.78905L6.368 2.79005Z",
    stroke: "#919191",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3V19",
    stroke: "#919191",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1V17",
    stroke: "#919191",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.3ec7857b9e209f1a10666f41d34b6fa0.svg";
export { ForwardRef as ReactComponent };